<template>
  <main>
    <div class="container-fluid">

      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="dayPeopleFlow-tab" data-bs-toggle="pill" data-bs-target="#dayPeopleFlow"
            type="button" role="tab" aria-controls="dayPeopleFlow" aria-selected="true"> 當日 </button>
        </li>

        <li class="nav-item" role="presentation">
          <button class="nav-link" id="sumPeopleFlow-tab" data-bs-toggle="pill" data-bs-target="#sumPeopleFlow"
            type="button" role="tab" aria-controls="sumPeopleFlow" aria-selected="true"> 統計 </button>
        </li>
      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <day-people-flow></day-people-flow>
        <sum-people-flow></sum-people-flow>
      </div>
    </div>
  </main>
</template>

<script>
import dayPeopleFlow from './dayPeopleFlow.vue';
import sumPeopleFlow from './sumPeopleFlow.vue';




export default {
  components: { dayPeopleFlow, sumPeopleFlow},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
